module.exports = __webpack_public_path__ + "img/icon-model-filled.aa40b06d.svg";